import { axiosInstance } from '@/utils/axiosInstance';
import { readStoreEntryState } from '@/utils/storeEntryState';

const LOG_BUNDLE_PRICE_URL =
  'https://imagesf.getninjas.com/log-bundle-price/index.php';

interface ILogBundlePricePurchase {
  // userState enviado no momento da compra
  userStateOnPurchase: string;
  paymentMethod: 'credit_card' | 'pix' | 'boleto';
  bundleNameId?: string;
  invoiceId?: string | number;
}

// Dispara um log (fire-and-forget) toda vez que uma compra é realizada,
// comparando o profileId/userState salvos na ENTRADA da loja (cookie) com o
// userState enviado no momento da COMPRA. Nunca deve quebrar o fluxo de compra.
export const logBundlePrice = async ({
  userStateOnPurchase,
  paymentMethod,
  bundleNameId,
  invoiceId,
}: ILogBundlePricePurchase): Promise<void> => {
  try {
    const entryState = readStoreEntryState();

    const data = {
      // dados salvos no cookie quando o usuário ENTROU na loja de moedas
      profileIdOnStoreEntry: entryState?.profileId ?? null,
      userStateOnStoreEntry: entryState?.userState ?? null,
      // userState que está sendo enviado no momento da COMPRA
      userStateOnPurchase,
      userStateChanged:
        entryState?.userState != null &&
        entryState.userState !== userStateOnPurchase,
      paymentMethod,
      bundleNameId: bundleNameId ?? null,
      invoiceId: invoiceId ?? null,
    };

    await axiosInstance({
      method: 'POST',
      url: LOG_BUNDLE_PRICE_URL,
      headers: {
        'Content-Type': 'application/json',
      },
      data,
    });
  } catch {
    // log-only: uma falha aqui não pode impactar a compra.
  }
};
